import RouteItem from ".";
import Cancellation from "../pages/policies/Cancellation";
import Conditions from "../pages/policies/Conditions";
import Privacy from "../pages/policies/Privacy";
import HyperLinking from "../pages/policies/HyperLinking";
import Copyright from "../pages/policies/Copyright";
import LegalDisclaimer from "../pages/policies/LegalDisclaimer";

export const policyRoutes: RouteItem = {
  key: "router-policies",
  title: "Policies",
  tooltip: "Policies",
  path: "/policies",
  enabled: true,
  appendDivider: true,
  subRoutesDirection: "vertical",
  subRoutes: [
    {
      key: "router-legal-disclaimer",
      title: "Legal Disclaimer",
      tooltip: "Legal Disclaimer",
      path: "legalDisclaimer",
      component: <LegalDisclaimer />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-copyright-policy",
      title: "CopyRight Policy",
      tooltip: "CopyRight Policy",
      path: "CopyRightPolicy",
      component: <Copyright />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-hyperlinking-policy",
      title: "HyperLinking Policy",
      tooltip: "HyperLinking Policy",
      path: "hyperLinkingPolicy",
      component: <HyperLinking />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-privacy-policy",
      title: "Privacy Policy",
      tooltip: "Privacy Policy",
      path: "privacyPolicy",
      component: <Privacy />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-terms-conditions",
      title: "Terms & Conditions",
      tooltip: "Terms & Conditions",
      path: "Conditions",
      component: <Conditions />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-cancellation-refund-policy",
      title: "Cancellation & ReFund Policy",
      tooltip: "Cancellation & ReFund Policy",
      path: "Cancellations",
      component: <Cancellation />,
      enabled: true,
      appendDivider: false, // Last sub-route should not have an appendix divider
    },
  ],
};
